<template>
  <div class="mod-article-inner">
    <preview-job-content-header title="関連リンク" />
    <p
      v-for="(link,i) in links"
      :key="i"
      class="mb0"
    >
      <a
        :href="link.url"
        rel="nofollow noopener noreferrer"
        target="blank"
        :data-test="`link-${i}`"
      >{{ link.text }}</a>
    </p>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'

export default {
  components: {
    PreviewJobContentHeader
  },
  props: {
    links: {
      type: Array,
      default: () => []
    }
  }
}
</script>
